module.exports = __webpack_public_path__ + "img/KatharinaBolten_140x140_rund.eb408843.jpg";